export default __webpack_public_path__ + "static/media/CoffeeBarExperts.de2df10a.png";